module.exports = __webpack_public_path__ + "img/vector-icon.8434d01b.svg";